import { Controller } from "@hotwired/stimulus"

// Renders one Rails flash message as a toastr notification. The element
// itself has no visible content -- toastr builds and injects its own
// toast UI (including the progress bar) into the document; this
// controller only reads the message/type off its own data attributes and
// hands them to toastr.
export default class extends Controller {
  connect() {
    this.positionBelowHeader()
    toastr[this.element.dataset.flashType](this.element.dataset.flashMsg)
  }

  // The header's actual height varies (a single navbar row normally,
  // taller when the account-expiry notice banner is also showing -- see
  // layouts/application.html.erb), so a fixed CSS pixel value can't
  // reliably track it. Measuring the real height and writing it to a CSS
  // custom property (read by #toast-container.toast-top-center's `top`
  // in components/_flash.scss) keeps the toast positioned just below the
  // header regardless of which state it's in.
  positionBelowHeader() {
    const header = document.querySelector("header")
    if (header) {
      document.documentElement.style.setProperty("--flash-top", `${header.offsetHeight}px`)
    }
  }
}
